import { JSONParse } from 'src/_helpers';
import { DirectMessagingAction } from '../_constants';
import moment from "moment-timezone";
const initialState = {
  message: [],
  client_id: '',
  customer_name: '',
  customer_phone: '',
  status: '',
  groups: []
}
export function DirectMessaging(state = initialState, action) {
  var DirectMessagingState = Object.assign({}, state)
  switch (action.type) {
    case DirectMessagingAction.NEW_CLIENT:
      return {
        ...action.client,
        group: DirectMessagingState.group
      };
    case DirectMessagingAction.INIT_GROUP:
      return {
        ...DirectMessagingState,
        group: action.groups
      };
    case DirectMessagingAction.NEW_GROUP:
      var groups = DirectMessagingState.group
      var group_data = JSONParse(action.item.data)
      var exited = groups.find(e => e.id === action.item.group_id)
      if (exited) {
        if (action.item.chat_type === 1)
          exited.last_customer_chat_at = moment().format()
        return {
          ...DirectMessagingState,
          group: groups.map(e => {
            if (e.id === exited.id) return { ...exited, ...group_data }
            return e
          })
        };
      } else {
        action.item.last_customer_chat_at = moment().format()
        DirectMessagingState.group = [
          {
            ...action.item,
            ...group_data,
            id: action.item.group_id,
            room_name: group_data.room,
          }
        ].concat(groups)
      }
      return {
        ...DirectMessagingState
      };
    case DirectMessagingAction.NEW_MSG_FC:
      var msg = DirectMessagingState.message
      if (action.item.group_id === DirectMessagingState.group_id) {
        msg.push(action.item)
        DirectMessagingState.message = msg
        DirectMessagingState.status = 'DONE'
      } else {
        console.log(action.item)
      }
      return { ...DirectMessagingState };
    case DirectMessagingAction.NEW_MSG:
      var msg = DirectMessagingState.message
      var group_data = JSONParse(action.item.data)
      msg.push(action.item)
      DirectMessagingState.message = msg
      DirectMessagingState.status = 'DONE'
      return { ...DirectMessagingState, ...group_data };
    default:
      return DirectMessagingState
  }
}